import { Component, h } from "preact";

import { Icon } from "../../Icon";

export function StarOutlineIcon(rest) {
  return (
    <Icon {...rest}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.9529 17.7167L25 1L18.0471 17.7167L0 19.1636L13.75 30.9419L9.54915 48.5528L25 39.1155L40.4509 48.5528L36.25 30.9419L50 19.1636L31.9529 17.7167ZM41.3201 21.9838L29.5389 21.0393L25 10.1266L20.4611 21.0393L8.67986 21.9838L17.6559 29.6728L14.9136 41.1693L25 35.0086L35.0864 41.1693L32.3441 29.6728L41.3201 21.9838Z"
      />
    </Icon>
  );
}
